

































import Vue from 'vue'
import Component from 'vue-class-component'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { getModule } from 'vuex-module-decorators'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Table from '@/components/tables/Table.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import DatepickerLabel from '@/components/labels/DatepickerLabel.vue'
import SelectLabel from '@/components/labels/SelectLabel.vue'
import { TransactionsModule } from '@/store/modules/transactions.module'
import { IResidentTransactionsLineItemsFilters } from '@zunta/configurations'
import moment from 'moment'

@Component({
  props: {
    residentId: {
      type: Number,
      required: true
    }
  },
  components: { LoaderWrapper, Table, DateTimeLabel, DatepickerLabel, SelectLabel }
})
export default class CollectionAgingTransaction extends Vue {
  transactionModuleInstance: TransactionsModule = getModule(TransactionsModule, this.$store)
  filters: IResidentTransactionsLineItemsFilters = {
    skip: 0,
    limit: 20
  }

  get transactionLineItems () {
    return this.$store.state.transactions.transactionResidentLineItems
      }

  get totalTransactionLineItems () {
    return this.$store.state.transactions.totalTransactionResidentLineItems
  }

  config: ITableConfig = {
    useQuery: true,
    usePagination: true,
    fetchFunction: this.fetchTransactionListItems,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 17px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    minHeight: '100px',
    maxHeight: 'calc(100vh - 430px)',
    columns: [
      {
        class: 'text-left',
        minWidth: '110px',
        width: 12,
        key: 'effectiveDate',
        searchKey: 'effectiveDate',
        hasSort: true,
        hasSearch: true,
        label: 'Effective date',
        type: ETableColumnType.dateRange
      },
      {
        class: 'text-left',
        minWidth: '110px',
        width: 12,
        key: 'billingDate',
        searchKey: 'billingDate',
        hasSort: true,
        hasSearch: true,
        label: 'Post Date',
        type: ETableColumnType.dateRange
      },
      {
        class: 'text-right',
        minWidth: '154px',
        width: 15,
        key: 'description',
        searchKey: 'description',
        hasSort: true,
        hasSearch: true,
        label: 'Description',
        type: ETableColumnType.default
      },
      {
        class: 'text-left',
        minWidth: '110px',
        width: 12,
        key: 'dateFrom',
        searchKey: 'dateFrom',
        hasSort: true,
        hasSearch: true,
        label: 'Date from',
        type: ETableColumnType.dateRange
      },
      {
        class: 'text-left',
        minWidth: '110px',
        width: 12,
        key: 'dateTo',
        searchKey: 'dateTo',
        hasSort: true,
        hasSearch: true,
        label: 'Date to',
        type: ETableColumnType.dateRange
      },
      {
        class: 'text-right',
        minWidth: '110px',
        width: 10,
        key: 'unitAmount',
        searchKey: 'unitAmount',
        hasSort: true,
        hasSearch: true,
        label: 'Unit Price',
        type: ETableColumnType.numberRange
      },
      {
        class: 'text-right',
        minWidth: '80px',
        width: 8,
        key: 'numberOfUnits',
        searchKey: 'numberOfUnits',
        hasSort: true,
        hasSearch: true,
        label: '# Units',
        type: ETableColumnType.number
      },
      {
        class: 'text-right',
        minWidth: '188px',
        width: 17,
        key: 'totalAmount',
        searchKey: 'totalAmount',
        hasSort: true,
        hasSearch: true,
        label: 'Amount',
        type: ETableColumnType.numberRange
      }
    ]
  }

  async fetchTransactionListItems (filters: IResidentTransactionsLineItemsFilters) {
    await this.transactionModuleInstance.getResidentTransactionLineItems({ residentId: this.$props.residentId, filters })
  }

  formatDate (dateString: string) {
    const date = moment(dateString).toDate()
    const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    const day = (date.getDate()) < 10 ? `0${date.getDate()}` : date.getDate()
    return `${month}/${day}/${date.getFullYear()}`
  }
}

